import React from 'react';

const ComingSoon = () => {
  return (
    <div className="w-full h-screen flex items-center justify-center bg-gray-100">
      <h1 className="text-6xl font-bold text-gray-800">
        Coming Soon
      </h1>
    </div>
  );
};

export default ComingSoon;